import Success from "../../assets/icons/svgs/success.svg";
import { BsFillCheckCircleFill } from "react-icons/bs";
import "./styles/RefundConfirmation.css";
import { useTranslation } from "react-i18next";
import "../../localisation/index"
export default function RefundConfirmation() {
  const {t} = useTranslation()
  return (
    <div className="refund-conf-page__container component">
      {/* <img src={Success} alt="" /> */}
      <BsFillCheckCircleFill className="refund-conf-page__icon" />
      <p className="refund-conf-page__msg">
        {t("refundSuccessMsg")}
      </p>
    </div>
  );
}
